export default {
  name: 'event-notifications',
  translationKey: 'event-notifications-module',
  routePrefix: 'event-notifications',
  routeNamePrefix: 'admin.event-notifications',
  directRoutesAvailable: false,
}
